import { useEffect, useState } from 'react';
import { AuthContext, User } from './AuthContext';
import { api } from '@/lib/api';

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const [user, setUser] = useState<User | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Check for existing token
    const token = api.getToken();
    if (token) {
      // Validate token against the backend
      api.validateToken()
        .then((result) => {
          setUser({ id: result.user.id, name: result.user.name });
        })
        .catch(() => {
          // Token invalid, clear it
          api.clearToken();
          setUser(null);
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      setIsLoading(false);
    }
  }, []);

  const login = (token: string) => {
    api.setToken(token);
    // Validate token and get user info
    api.validateToken()
      .then((result) => {
        setUser({ id: result.user.id, name: result.user.name });
      })
      .catch(() => {
        api.clearToken();
        setUser(null);
      });
  };

  const logout = () => {
    api.clearToken();
    setUser(null);
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        isLoading,
        isAuthenticated: !!user,
        login,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}
